import React, { FC } from 'react';

// import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

import { modalActions } from '@contexts/common/ModalContext';

import useAdvancedFilters from '@hooks/vaults/useAdvancedFilters';

import Button from '@components/common/Button';
import FilterTabs from '@components/common/FilterTabs';
import Input from '@components/common/Input';
import Loader from '@components/common/Loader';
// import SelectedFilter from '@components/vaults/SelectedFilter';
import ModalWrapper from '@components/common/Modal/ModalWrapper';
import Select from '@components/common/Select';
import Slider from '@components/common/Slider';
import SortButton from '@components/common/SortButton';

import { SliderVariant, Variant } from '@constants/common/ui.constants';
import {
  FARMS_FILTER_TABs,
  SORT_VAULTS_MOB,
  V3_FARMS_FILTER_TABs,
  VAULTS_FILTER_TABs,
} from '@constants/vaults/common.constants';

import Box from './Box';
import Ranges from './Ranges';
import Tags from './Tags';
import useStyles from './styles.module';

const AdvancedFilters: FC = () => {
  const { classes } = useStyles();

  const {
    input,
    tags,
    ranges,
    sort,
    actions,
    v3Type,
    strategy,
    farmTypes,
    riskLevel,
    profitLevel,
    platforms,
    profitTokens,
    badges,
    platformOptions,
    profitTokensOptions,
    disabledV3Type,
    isGlobalLoading,
  } = useAdvancedFilters();

  return (
    <ModalWrapper title="Advanced Filters" classNameMobPopup={classes.modal}>
      {isGlobalLoading ? (
        <div className={classes.loaderBox}>
          <Loader size={32} />
        </div>
      ) : (
        <div className={classes.container}>
          {/* {!!tags?.length && ( */}
          {/*   <div className={classes.selectedFilters}> */}
          {/*     {tags.map((item) => ( */}
          {/*       <SelectedFilter */}
          {/*         key={item.value} */}
          {/*         title={item.label} */}
          {/*         onClick={() => actions.onTags(item)} */}
          {/*       /> */}
          {/*     ))} */}
          {/*     <Button */}
          {/*       size={SIZE.SMALL} */}
          {/*       variant={VARIANT.TEXT} */}
          {/*       endIcon={<DeleteOutlinedIcon />} */}
          {/*       onClick={actions.onClear} */}
          {/*     > */}
          {/*       Clear */}
          {/*     </Button> */}
          {/*   </div> */}
          {/* )} */}

          <Box>
            <div className={classes.inner}>
              <div className={classes.tabs}>
                <FilterTabs
                  options={VAULTS_FILTER_TABs}
                  onClick={actions.onStrategy}
                  className={classes.filterTabs}
                  selectedValues={strategy}
                />

                <FilterTabs
                  options={FARMS_FILTER_TABs}
                  onClick={actions.onFarmTypes}
                  className={classes.farmsTabs}
                  selectedValues={farmTypes}
                />

                <FilterTabs
                  selectedValues={v3Type}
                  disabled={disabledV3Type}
                  options={V3_FARMS_FILTER_TABs}
                  className={classes.V3farmsTabs}
                  onClick={actions.onV3Type}
                />
              </div>
              <Ranges
                list={ranges}
                v3Type={v3Type}
                farmTypes={farmTypes}
                onClick={actions.onRanges}
                className={classes.rangesBox}
              />
            </div>
          </Box>

          <Box title="BY KEYWORD:">
            <Input
              isDark
              isSearch
              value={input}
              onChange={actions.onInputChange}
              placeholder="Search by publisher name, token, etc..."
            />
          </Box>

          <Box title="SORT BY:">
            <div className={classes.innerSelects}>
              <div className={classes.selectBox}>
                <Select
                  placeholder="Sort by"
                  value={sort.sortBy}
                  options={SORT_VAULTS_MOB}
                  onChange={(e) => actions.onSortBy(e.target.value as string)}
                />
                <SortButton
                  type={sort.sortDirection}
                  onSort={actions.onSortDirection}
                  className={classes.selectSortButton}
                />
              </div>

              <Select
                multiple
                value={profitTokens}
                options={profitTokensOptions}
                onChange={actions.onSetProfitToken}
                placeholder="Profit"
              />
              <Select
                multiple
                value={platforms}
                options={platformOptions}
                onChange={actions.onSetPlatform}
                placeholder="Platform"
              />
            </div>
          </Box>

          <div className={classes.slidersBox}>
            <Box title="RISK LEVEL:">
              <Slider
                isRangeSlider
                value={riskLevel}
                onChange={actions.onRiskLevel}
                className={classes.slider}
                variant={SliderVariant.Warning}
                valueLabelFormat={(value) => `${value}%`}
              />
            </Box>

            <Box title="COMPOUND vs. PROFIT:">
              <Slider
                isRangeSlider
                value={profitLevel}
                className={classes.slider}
                onChange={actions.onProfitLevel}
                valueLabelFormat={(value) => `${value}%`}
              />
            </Box>
          </div>

          <Box title="TAGS:">
            <Tags tags={tags} badges={badges} onTag={actions.onTags} />
          </Box>

          <div className={classes.btnBox}>
            <Button
              onClick={modalActions.hide}
              variant={Variant.Secondary}
              className={classes.btn}
              fullWidth
            >
              Cancel
            </Button>
            <Button fullWidth className={classes.btn} onClick={actions.onApply}>
              Apply
            </Button>
          </div>
        </div>
      )}
    </ModalWrapper>
  );
};

export default AdvancedFilters;
